import React, { Component } from "react";
import { Modal, Form, Row, Col } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./TarefasForm.css";

export default class TarefaForm extends Component {
  state = {
    tarefa: {
      id: '',
      titulo: '',
      descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.tarefaSelecionada !== propsAnterior.tarefaSelecionada) {
      this.setState({
        tarefa: this.props.tarefaSelecionada
      }, () => {
        this.refs.titulo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { tarefa } = this.state;
    tarefa[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if (checkFormIsValid(this.refs)) {
      this.props.onSalvarClick(this.state.tarefa);
    }
  };

  render() {
    const { onSalvarClick, onCancelarClick, carregando, visivel } = this.props;
    const { id, titulo, descricao } = this.state.tarefa;

    return (
      <Modal
        title={id ? "Edição de Tarefas" : "Cadastro de Tarefa"}
        visible={visivel}
        onText="Salvar"
        confirmLoading={carregando}
        onOk={this.onOK}
        onCancel={onCancelarClick}
        destroyOnClose
      >
        <Form>
          <Row>
            <Col xs={24} sm={6} className="tarefasForm-campos">
              {/* {id ? ( */}
                <InputForm
                  id="id"
                  label="ID"
                  value={id}
                  disabled
                  />
              {/* ) : null} */}
            </Col>


            <Col xs={24} sm={18}>
              <InputForm
                id="titulo"
                ref="titulo"
                label="Titulo"
                maxLength={50}
                onChange={this.onChange}
                value={titulo}
                validator={value => Boolean(value)}
                errorMessage="Informe o Título da Tarefa"
                required
              />
            </Col>
            <Col xs={24}>
              <InputForm
                id="descricao"
                ref="descricao"
                label="Descrição"
                type="textarea"
                rows={4}
                maxLength={4000}
                onChange={this.onChange}
                value={descricao}
                validator={value => Boolean(value)}
                errorMessage="Informe a Descrição da Tarefa"
                required
              />
            </Col>

          </Row>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TarefaForm.js